import { createSlice } from "@reduxjs/toolkit";
import { InitialState } from "../interfaces/pricing.interfaces";

const initialState: InitialState = {
  isLoading: false,
  data: {
    page: 1,
    limit: 100,
  },
};

const saveStatePageNumberLimit = createSlice({
  name: "Save the state page number",
  initialState,
  reducers: {
    savePageLimit(state, action) {
      state.data = action.payload;
    },
  },
});

export const { savePageLimit } = saveStatePageNumberLimit.actions;
export default saveStatePageNumberLimit.reducer;
